// App.jsx
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from "./Main";
import ErrorPage from "./ErrorPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:username" element={<Main />} />
        <Route path="/404" element={<ErrorPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}